import _URLSearchParams from "@babel/runtime-corejs3/core-js-stable/url-search-params";
import zenPerformance from '@zenlayer/zen-performance';
import { useCreation, useMemoizedFn, useRequest, useSafeState, useUnmount, useUpdateEffect } from 'ahooks';
import qs from 'query-string';
import { keys, omit } from 'ramda';
import { useEffect, useRef } from 'react';
import { generateUuid } from '../_util/utils';
import notification from '../notification'; // TODO 这里没有引入notification样式
import { DEFAULT_pageNum, DEFAULT_pageSize, DEFAULT_pageSizeOptions } from '../pagination/pagination';
const defaultPagination = {
  pageNum: DEFAULT_pageNum,
  pageSize: DEFAULT_pageSize,
  total: 0
};
const getUrlSearch = () => {
  return new _URLSearchParams(window.location.search.replace(/^\?+/, '')); // 移除开头的?解决详情跳转url出现双?的问题
};
export function useRequestList(request) {
  var _defaultParams$pageNu, _defaultParams$pageSi;
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const urlSearch = getUrlSearch();
  const reoladFlag = urlSearch.get('reload');
  const {
    defaultParams,
    error = true,
    paramsKeyInUrl = 'query',
    ready = true,
    emptyIgnoredParams = [],
    onFinally
  } = options;
  let _defaultParams = {
    ...defaultParams,
    pageNum: (_defaultParams$pageNu = defaultParams === null || defaultParams === void 0 ? void 0 : defaultParams.pageNum) !== null && _defaultParams$pageNu !== void 0 ? _defaultParams$pageNu : defaultPagination.pageNum,
    pageSize: (_defaultParams$pageSi = defaultParams === null || defaultParams === void 0 ? void 0 : defaultParams.pageSize) !== null && _defaultParams$pageSi !== void 0 ? _defaultParams$pageSi : defaultPagination.pageSize
  };
  const urlSearchParamsStr = paramsKeyInUrl ? urlSearch.get(paramsKeyInUrl) : null;
  if (typeof urlSearchParamsStr === 'string' && urlSearchParamsStr) {
    const urlSearchParams = qs.parse(urlSearchParamsStr, {
      arrayFormat: 'bracket'
    });
    _defaultParams = {
      ..._defaultParams,
      ...urlSearchParams,
      pageNum: Number(urlSearchParams.pageNum) > 0 ? Number(urlSearchParams.pageNum) : _defaultParams.pageNum,
      pageSize: typeof urlSearchParams.pageSize === 'string' && DEFAULT_pageSizeOptions.includes(urlSearchParams.pageSize) ? Number(urlSearchParams.pageSize) : _defaultParams.pageSize
    };
  }
  const [paramStates, setParamStates] = useSafeState({
    ..._defaultParams,
    total: 0
  });
  const [data, setData] = useSafeState([]);
  const [isEmpty, setIsEmpty] = useSafeState(false);
  const [initing, setIniting] = useSafeState(true);
  const requestId = useRef();
  const timer = useRef();
  const productListPerformance = useRef(new zenPerformance.observer.productList(location.pathname));
  const onError = response => {
    if (timer.current) {
      window.clearTimeout(timer.current);
    }
    if (error === false) {
      return;
    }
    let errorContent = {
      description: response.msg
    };
    if (typeof error === 'function') {
      errorContent = {
        ...errorContent,
        ...error(response)
      };
    }
    notification.error(errorContent);
  };
  const openRefreshTimer = function () {
    let delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10000;
    let callback = arguments.length > 1 ? arguments[1] : undefined;
    if (timer.current) {
      window.clearTimeout(timer.current);
    }
    timer.current = window.setTimeout(() => {
      callback === null || callback === void 0 || callback();
      decoratedRequest();
    }, delay);
  };
  const {
    pagination,
    query
  } = useCreation(() => {
    const {
      pageNum,
      pageSize,
      total,
      ...rest
    } = paramStates;
    return {
      pagination: {
        pageNum,
        pageSize,
        total
      },
      query: rest
    };
  }, [paramStates]);
  const decoratedRequest = useMemoizedFn(async function (params) {
    var _defaultParams$pageNu2, _defaultParams$pageSi2;
    let merge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    const mergedParams = merge ? {
      ...paramStates,
      ...params
    } : {
      ...defaultParams,
      pageNum: (_defaultParams$pageNu2 = defaultParams === null || defaultParams === void 0 ? void 0 : defaultParams.pageNum) !== null && _defaultParams$pageNu2 !== void 0 ? _defaultParams$pageNu2 : defaultPagination.pageNum,
      pageSize: (_defaultParams$pageSi2 = defaultParams === null || defaultParams === void 0 ? void 0 : defaultParams.pageSize) !== null && _defaultParams$pageSi2 !== void 0 ? _defaultParams$pageSi2 : defaultPagination.pageSize,
      ...params
    };
    // 将值为undefined的参数过滤掉
    const filteredParams = Object.keys(mergedParams).reduce((acc, key) => {
      const k = key;
      const value = mergedParams[k];
      if (value !== undefined) {
        acc[k] = value;
      }
      return acc;
    }, {});
    const id = generateUuid();
    requestId.current = id;
    setParamStates({
      ...filteredParams,
      total: paramStates.total
    });
    const reqParams = omit(['total'], filteredParams);
    const response = await request(reqParams);
    if (id === requestId.current) {
      var _data$list;
      const {
        success,
        data
      } = response;
      if (success) {
        setParamStates({
          ...filteredParams,
          // pageNum: data.pageNum || filteredParams.pageNum,
          total: data.total
        });
      } else {
        onError(response);
      }
      // 初次请求时
      if (initing) {
        const omitParams = ['pageNum', 'pageSize', 'total', ...emptyIgnoredParams];
        if (!data.total && !keys(omit(omitParams, filteredParams)).length && filteredParams.pageNum === 1) {
          setIsEmpty(true);
        }
        setIniting(false);
      } else if (data.total) {
        setIsEmpty(false);
      }
      if (onFinally) {
        onFinally({
          result: data,
          params: reqParams,
          openRefreshTimer
        });
      }
      setData((_data$list = data.list) !== null && _data$list !== void 0 ? _data$list : []);
    }
  });
  const {
    loading,
    runAsync
  } = useRequest(decoratedRequest, {
    ready,
    onBefore: () => {
      if (paramsKeyInUrl) {
        productListPerformance.current.productListStart();
      }
    },
    onFinally: () => {
      if (paramsKeyInUrl) {
        productListPerformance.current.productListEnd();
      }
    }
  });
  useEffect(() => {
    // 缓存查询条件在url中
    if (paramsKeyInUrl) {
      const newUrlSearch = getUrlSearch();
      newUrlSearch.set(paramsKeyInUrl, qs.stringify(paramStates, {
        arrayFormat: 'bracket'
      }));
      const newUrlSearchStr = "?".concat(newUrlSearch.toString());
      if (newUrlSearchStr !== window.location.search) {
        window.history.replaceState({}, '', window.location.pathname + newUrlSearchStr);
      }
    }
  }, [paramStates]);
  useUpdateEffect(() => {
    if (reoladFlag) {
      const params = urlSearchParamsStr ? qs.parse(urlSearchParamsStr, {
        arrayFormat: 'bracket'
      }) : {};
      runAsync(params, false);
    }
  }, [reoladFlag]);
  useUnmount(() => {
    if (timer.current) {
      window.clearTimeout(timer.current);
    }
  });
  return {
    data,
    pagination: {
      ...pagination,
      onChange: (pageNum, pageSize) => {
        runAsync({
          pageNum,
          pageSize
        });
      }
    },
    query,
    initing,
    loading,
    isEmpty,
    refresh: runAsync,
    refreshQuietly: decoratedRequest,
    mutate: setData
  };
}